import React, { Component } from 'react';
import './login.css';
import AuthService from '../../services/AuthService';
import { Modal, Container, Row, Col } from 'reactstrap';

const logo = require('../../groupe-seenergi.png');
const Auth = new AuthService();

interface ILoginState {
    username: string;
    password: string;
}
interface ILoginProps {
    isOpen: boolean;
    close: () => void;
}
export class LoginModal extends Component<ILoginProps,ILoginState> {

    constructor(props: any){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentWillMount(){
        if(Auth.loggedIn())
            this.props.close();
    }
    
    render() {
        
        return (
            <Modal isOpen={this.props.isOpen}>
            <Container className="padded" >
                <Row >
                    <Col md={12} className="textAlignCenter">
                    <img src={logo} alt="logo" width="50%"/>
                    <h3>Authentifiez vous à l'interface de management de l'API de la BD SEENERGI</h3>
                    </Col>
                    <div className="center">
                    <form onSubmit={this.handleFormSubmit}>
                        <input
                            className="form-item"
                            placeholder="Username"
                            name="username"
                            type="text"
                            onChange={this.handleChange}
                        />
                        <input
                            className="form-item"
                            placeholder="Password"
                            name="password"
                            type="password"
                            onChange={this.handleChange}
                        />
                        <input
                            className="form-submit"
                            value="SUBMIT"
                            type="submit"
                        />
                    </form>
                    </div>
                </Row>
            </Container>
            </Modal>
        );
    }

    handleChange(e: any){
        this.setState(
            {
                [e.target.name]: e.target.value
            }  as ILoginState
        )
    }

    handleFormSubmit(e: any){
        e.preventDefault();
        Auth.login(this.state.username,this.state.password)
            .then(res =>{
               this.props.close();
               window.history.go();
            })
            .catch(err =>{
                //alert(err);
                alert("Les identifiants sont erronés");
            })
    }
}
